<template lang="pug">
what-is-modal(ref="whatIsNumberModal"
  :img-src="`${config.baseUri}/images/supercharged/giftcard-example.png`"
  sub-text="Please note, if the Gift Card was purchased online, the Gift Card number can be found in the email that was sent after the purchase was done or under the 'My Gift Cards' section of your Account.")
</template>

<script>
import ConfigMixin from '../_mixins/config'

export default {
  name: 'what-is-giftcard-number-modal',

  mixins: [
    ConfigMixin,
  ],

  methods: {
    show() {
      this.$refs.whatIsNumberModal.show()
    }
  }
}
</script>
